import React from 'react'
import { useModalContext } from 'app/modal'
import GameContainer from '../GameContainer'
import { SecondaryButton } from 'shared/Buttons'
import { usePlayGameContext } from '../playGameContext'
import { Away, Home } from '../Players/PlayersRows'
import { Panel } from '../elements'
import Card from 'shared/Card'
import { ChartIcon, LargeIcon } from 'app/icons'
import Stack from 'shared/content-control/Stack'
import { ScoreChart } from 'components/play/ScoreBoard'

/**
 * Shows the ScoreBoard UI
 * @param {boolean} param0.isRoundComplete: This menas the model self opened as a result of the round being completed.
 */
const ScoreBoardModal = () => {
  const { closeModal } = useModalContext()
  const {
    startedGame,
    startedGame: {
      players: { home },
      isRoundComplete,
    },
  } = usePlayGameContext()

  const showChart = home.score.length

  const subtitle = showChart
    ? 'The lowest scoring player wins'
    : 'Complete your first round to see the score board'

  const getTitle = (isRoundComplete) => {
    if (isRoundComplete)
      return `You ${home.isRoundWinner ? 'win' : 'lose'} this round`
    return home.isGameWinner
      ? 'Board of Fame'
      : home.isGameLoser
      ? 'Board of Shame'
      : 'Score board'
  }
  return (
    <GameContainer addModal={false}>
      <Away {...{ startedGame }} />
      <Panel>
        <h1>{getTitle(isRoundComplete)}</h1>
        <Panel>
          <Card>
            <Card.Body>
              <Stack space={1}>
                {showChart ? (
                  <ScoreChart startedGame={startedGame} />
                ) : (
                  <LargeIcon style={{ margin: 'auto' }}>
                    <ChartIcon />
                  </LargeIcon>
                )}
                <div>{subtitle}</div>
              </Stack>
            </Card.Body>
          </Card>
        </Panel>
        <SecondaryButton onClick={closeModal} style={{ marginTop: '1rem' }}>
          ok
        </SecondaryButton>
      </Panel>
      <Home {...{ startedGame }} />
    </GameContainer>
  )
}

export default ScoreBoardModal
